import { Fragment } from 'react'

import { GameId, ProductV2 } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import BrawlPassesIcon from '@/assets/images/storefronts/brawlstars/pass-icon.png'
import BrawlFlare from '@/assets/images/storefronts/brawlstars/shop_item_bg_flare.png'
import CoCPassesIcon from '@/assets/images/storefronts/clashofclans/passes-icon.png'
import { PASSES_BG } from '@/features/storefronts/_storeBase/constants'
import { PassCard } from '@/features/storefronts/_storeBase/passCard/PassCard'
import SideScrollable from '@/features/storefronts/_storeBase/structure/SideScrollable'
import { useGameSlug } from '@/features/storefronts/game-provider'
import { useBreakpoints } from '@/utils/useBreakpoints'

import { PassCardBrawl } from '../../brawlstars/passCard/PassCardBrawl'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './Passes.module.scss'

interface PassesProps {
  products: ProductV2[]
  background?: boolean
}
const Passes: React.FC<PassesProps> = ({ products, background = true }) => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const from = useBreakpoints().from
  const isDesktop = from('tablet')

  const passes = products.filter((p) => p.contentCounts.SEASON_PASS)

  const passesIcon = (gameSlug: GameId) => {
    switch (gameSlug) {
      case 'brawlstars':
        return BrawlPassesIcon
      case 'clashofclans':
        return CoCPassesIcon
      case 'clashroyale':
        return CoCPassesIcon
      default:
        return CoCPassesIcon
    }
  }

  return passes.length > 0 ? (
    <div
      className={cx(styles[gameSlug], styles.Passes, styles.Background)}
      style={{ ...(background && { backgroundImage: PASSES_BG(gameSlug) }) }}
    >
      <div className={styles.Header}>
        <div className={styles.HeaderImage}>
          <Image src={passesIcon(gameSlug)} alt="gold-and-event-passes" fill sizes="100px" />
        </div>
        <div id="passes" className={styles.headerText}>
          <StoreTypography tag="h2" textSize={isDesktop ? 'xl' : 'lg'} style="outlined">
            {t('passes_title')}
          </StoreTypography>
        </div>
      </div>

      <div className={styles.Center}>
        {gameSlug === 'brawlstars' && (
          <div className={styles.bgFlare}>
            <Image src={BrawlFlare} fill style={{ objectFit: 'contain' }} alt="brawl flare" />
          </div>
        )}
        <SideScrollable className={styles.Scrollable} centered>
          {passes.map((pass) => (
            <Fragment key={pass.id}>
              {gameSlug === 'brawlstars' ? (
                <PassCardBrawl key={pass.id} product={pass} />
              ) : (
                <PassCard key={pass.id} product={pass} />
              )}
            </Fragment>
          ))}
        </SideScrollable>
      </div>
    </div>
  ) : null
}

export default Passes
